export interface IAddress {
  isDefaultAddress: boolean;
  name: string;
  detail: string;
  addressDetail: {
    postalCode: string;
    longitude: string;
    latitude: string;
    vsatId: string;
    uniqueAddressCode: number;
    bbkCode: number;
    addressLocationId: string;
    addressTypeId: string;
    creationSource: string;
  };
  customerId: string;
  isForeign: boolean;
  nationalityId: number | string;
  city: any;
  town: any;
  townShip: any;
  village: any;
  district: any;
  street: any;
  building: any;
  door: any;
}

export const addressInitials: IAddress = {
  isDefaultAddress: false,
  name: "",
  detail: "",
  addressDetail: {
    postalCode: "",
    longitude: "",
    latitude: "",
    vsatId: "",
    uniqueAddressCode: 0,
    bbkCode: 0,
    addressLocationId: "",
    addressTypeId: "",
    creationSource: "Bayi",
  },
  customerId: "",
  isForeign: false,
  nationalityId: "",
  city: "",
  town: "",
  townShip: "",
  village: "",
  district: "",
  street: "",
  building: "",
  door: "",
};

export interface IOptions {
  value: string;
  label: string;
}

export interface IAddressProduct {
  city: IOptions;
  town: IOptions;
  townShip: IOptions;
  village: IOptions;
  district: IOptions;
  street: IOptions;
  building: IOptions;
  door: IOptions;
  postalCode: number;
  address1: string;
}

export const addressProduct: IAddressProduct = {
  city: {
    value: "",
    label: "",
  },
  town: {
    value: "",
    label: "",
  },
  townShip: {
    value: "",
    label: "",
  },
  village: {
    value: "",
    label: "",
  },
  district: {
    value: "",
    label: "",
  },
  street: {
    value: "",
    label: "",
  },
  building: {
    value: "",
    label: "",
  },
  door: {
    value: "",
    label: "",
  },
  postalCode: 0,
  address1: "",
};
